
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiLightningLightSnowShowersPolartwilightColour as ObiLightningLightSnowShowersPolartwilightColourElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-lightning-light-snow-showers-polartwilight-colour.js';
 
 
 

 
 export const ObiLightningLightSnowShowersPolartwilightColour = createComponent({
   react: React,
   tagName: 'obi-lightning-light-snow-showers-polartwilight-colour',
   elementClass: ObiLightningLightSnowShowersPolartwilightColourElement,
   events: {
     
   }
  });
 
 